{
  "wreck": { "sg": "Wrack", "pl": "Wracks", "gender": "n" },
  "hull_fragment": { "sg": "Rumpffragment", "pl": "Rumpffragmente", "gender": "n" },
  "life_raft": { "sg": "Rettungsinsel", "pl": "Rettungsinseln", "gender": "f" },
  "flight_recorder": { "sg": "Flugschreiber", "pl": "Flugschreiber", "gender": "m" },
  "logbook": { "sg": "Logbuch", "pl": "Logbücher", "gender": "n" },
  "compass": { "sg": "Kompass", "pl": "Kompasse", "gender": "m" },
  "distress_call": { "sg": "Notruf", "pl": "Notrufe", "gender": "m" },
  "survivor": { "sg": "Überlebender", "pl": "Überlebende", "gender": "m" },
  "sonar_contact": { "sg": "Sonarkontakt", "pl": "Sonarkontakte", "gender": "m" },
  "anomaly": { "sg": "Anomalie", "pl": "Anomalien", "gender": "f" },
  "trench": { "sg": "Graben", "pl": "Gräben", "gender": "m" },
  "research_base": { "sg": "Forschungsbasis", "pl": "Forschungsbasen", "gender": "f" },
  "submarine": { "sg": "U-Boot", "pl": "U-Boote", "gender": "n" },
  "vessel": { "sg": "Schiff", "pl": "Schiffe", "gender": "n" },
  "aircraft": { "sg": "Flugzeug", "pl": "Flugzeuge", "gender": "n" },
  "crew_member": { "sg": "Besatzungsmitglied", "pl": "Besatzungsmitglieder", "gender": "n" },
  "clue": { "sg": "Hinweis", "pl": "Hinweise", "gender": "m" },
  "storm": { "sg": "Sturm", "pl": "Stürme", "gender": "m" },
  "current": { "sg": "Strömung", "pl": "Strömungen", "gender": "f" },
  "debris_field": { "sg": "Trümmerfeld", "pl": "Trümmerfelder", "gender": "n" }
}
